import { render, staticRenderFns } from "./TestChat.vue?vue&type=template&id=3431482a&"
import script from "./TestChat.vue?vue&type=script&lang=js&"
export * from "./TestChat.vue?vue&type=script&lang=js&"
import style0 from "./TestChat.vue?vue&type=style&index=0&id=3431482a&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports